// extracted by mini-css-extract-plugin
export var measureBox = "_46-0";